import AccessRights from './AccessRights';

export default AccessRights;
